// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .p-select {
    width: 10em !important;
    height: 1.5em !important;
    border: 1px solid whitesmoke !important;
    margin-right:10px;
}

:host ::ng-deep .p-select:hover,
:focus {
    border-color: whitesmoke !important;
}

:host ::ng-deep .p-select .p-select-dropdown {
    background-color: rgb(33, 37, 41);
    width: 1.5em;
    color: #fff;
}

:host ::ng-deep .p-select-list-container {
    border-radius: 3px;
}

:host ::ng-deep .p-select .p-select-label {
    width: 100%;
    height: 100%;
    text-align: center;
    padding: 0 !important;
    background: rgb(33, 37, 41);
    color: #fff !important;
    font-size: 12px;
    margin-right: 0.5px;
    font-family: "EYInterstate-light";
}

:host ::ng-deep .p-select-overlay {
    width: 10em !important;
    background: rgb(33, 37, 41) !important;
    border: 0;
    color: #fff !important;
}

:host ::ng-deep .p-select-overlay .p-select-list {
    padding: 0;
    border: 0;
    background: rgb(33, 37, 41) !important;
    color: #fff !important;
}

.display-flex {
    display: flex;
}

:host ::ng-deep .p-select-overlay .p-select-option {
    min-height: 20px !important;
    padding: 3px 7px !important;
    line-height: 0.8em !important;
    font-size: 12px;
    background: rgb(33, 37, 41) !important;
    color: #fff !important;
    &:hover{
        background-color: #80bdff !important;
    }
}

:host ::ng-deep .p-select-overlay .p-select-option.p-focus,
:host ::ng-deep .p-select-overlay .p-select-option.p-select-option-selected {
    color: #212529 !important;
    background-color: #ffe082 !important;
    &:hover{
        background-color: #80bdff !important;
    }
}

.lang-disabled {
    color: lightgray;
    cursor: not-allowed;
    opacity: 0.5;
}
.spacing {
  padding-right: 0.7rem !important;
}

:host ::ng-deep .p-menu > ul {
    padding: 0;
}
.lang-select {
    .p-select {
        width: 10.4rem !important;
        .p-select-label {
            border-radius: 3px !important;
            border-right: 1px solid !important;
        }
    }
}

`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
